<template>
  <div class="body-mobile">
		<div class="wrapper-body">
			<div class="wrapper-body__header">
				<nav-step :active="4"></nav-step>
			</div>
			<div class="wrapper-body__body">
				<div class="wrapper-body__body__title">
					<p>报名成功<span>（4/4）</span></p>
				</div>
				<div class="wrapper-body__body__container">
					<div class="bm_info_items" v-if="applyData" id="appData">
						<h2 class="sx-align-center" style="margin-top:.2rem;">资料提交成功</h2>
						<div class="_item"><span>预报名号：</span><font>{{applyData.id}} <i>（请牢记预报名号）</i></font></div>
						<div class="_item"><span>预约日期：</span><font>{{applyData.orderDate}} <i>（{{applyData.amPmTypeName}}{{applyData.beginTime}}-{{applyData.endTime}}）</i></font></div>
						<div class="_item" v-if="studentType === 1"><span>所报幼儿园：</span><font>{{applyData.orderSchoolName}}</font></div>
						<div class="_item" v-else><span>预约街道：</span><font>{{applyData.orderStreetName}}</font></div>
						<div class="_item sub_item" style="margin-top:.25rem;"><span style="font-size:0.32rem;">报名信息：</span>{{studentTypeName}}姓名：{{applyData.name}}</div>
						<div class="_item sub_item"><span></span>{{studentTypeName}}身份证号：<i>{{applyData.idCard}}</i></div>
						<div class="_item sub_item"><span></span>出生日期：{{applyData.birthday}}</div>
						<div class="_item sub_item" v-if="studentType === 2"><span></span>所报年级：{{applyData.orderGradeName}}</div>
						<div class="_item type_item"><span>审核状态：</span><font>{{applyData.statusName}}</font></div>
						<div class="text-error" style="margin:0 .4rem;">
							温馨提示：<br>
              1.请携带审核资料，于{{applyData.orderDate}}（{{applyData.amPmTypeName}}{{applyData.beginTime}}-{{applyData.endTime}}）前往前往指定幼儿园进行现场审核<span v-if="config.web.areaId!=='513426'">，详见<a :href="config.web.areaId==='510112'?'https://mp.weixin.qq.com/s/aeGd7c20hlpasHySWJUAhg':'https://mp.weixin.qq.com/s/-ZOPeSKB7joKQAnThMkCZQ'" target="_blank">官方公众号相关说明</a></span>；<br>
              2.若未在{{this.studentType === 1 ? '自己预约的' : '规定'}}时间内办理资料审核，请再进入系统“我要查询->修改报名信息”，进行预约时间修改。
						</div>
					</div>
				</div>
			</div>

      <!-- 审核资料 -->
      <div style="color:#fff;margin-top:10px;" @click="showCheckList=true"><md-icon name="card-bag"></md-icon> 审核资料清单</div>
      <div class="mask" v-if="!!showCheckList" @click="showCheckList=false"></div>
      <div v-show="!!showCheckList" class="dialog-check-list">
        <div class="bm_info_right" v-if="config.web.areaId==='510112'">
          <h2>需携带资料</h2>
          <b>一般家庭需要提交的资料：</b><br>
          监护人身份证原件及复印件、幼儿户口簿原件及复印件（户口簿首页、监护人页、幼儿页）。<br><br>

          <b>拆迁未安置家庭需要提交的资料：</b><br>
          监护人身份证原件及复印件、幼儿户口簿原件及复印件（户口簿首页、监护人页、幼儿页）、拆迁协议、租住房屋者提供《房屋租赁登记备案凭证》、自购房者提供房产证明或购房合同，并同时提供有二维码验证标识的《房屋信息查询记录》或《网签合同信息查询记录》。<br><br>

          <b>拆迁已安置、户籍未迁移家庭需提交的资料：</b><br>
          监护人身份证原件及复印件、幼儿户口簿原件及复印件（户口簿首页、监护人页、幼儿页）、拆迁协议和分房协议。
        </div>
        <div class="bm_info_right" v-else>
          <h2>需携带资料</h2>
          <b>一现场确认监护人需要提交的资料：</b><br>
          幼儿法定监护人身份证和幼儿户口簿原件及复印件（户主页和幼儿信息页）、幼儿出生证明（申请未入园子女与当年入园子女绑定者）<br><br>
        </div>
      </div>

			<div class="wrapper-body__footer">
				<div class="box-btns" v-if="applyData">
          <span class="button-primary" id="renderPdf" v-show="false">保存预报名号</span>
          <span class="button-primary" @click="onClickSaveBtn">保存预报名号</span>
					<span
						v-if="applyData.status === 0"
						class="button-primary-inset"
						@click="onClickChangeBtn">修改报名信息</span>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
  import IndexCommon from '../index/mixins/index_common';
  import MobileCommon from '../index/mixins/mobile_common';
  import PageBmInfo from '../index/mixins/page_bm_info';

  import config from '@/../config'

  export default {
    mixins: [IndexCommon, MobileCommon, PageBmInfo],
    components: {},
    data() {
      return {
        config,
        // 显示审核资料
        showCheckList:false
      }
		},
		created() {
			// let self = this;
			// if (window.history && window.history.pushState) {
			// 	window.addEventListener('popstate', function() {
			// 		var hashLocation = location.hash; var hashSplit = hashLocation.split('#!/');
			// 		var hashName = hashSplit[1];
			// 		if (hashName !== '') {
			// 			var hash = window.location.hash; if (hash === '') {
			// 				// alert('後退按鈕點擊');
			// 				self.$router.push({
			// 					path: './index'
			// 				});
			// 		}
			// 		}
			// 	});
			// }
		},
    methods: {
      onClickSaveBtn() {
        this.$message.success('手机端请截图保存预报名号！');
      }
    }
  }
</script>

<style lang="stylus" scoped>
	.body-mobile
		.wrapper-body
			.wrapper-body__body__container
				padding 0 .1rem;
  .bm_info_items {
		padding-bottom: 20px;
    h2 {
      color #f65b55;
    }
    ._item {
      font-size 32px;
      color #999999;
      line-height 80px;
      span {
        display inline-block;
        width 200px;
        text-align right;
      }
      font {
        color #f65b55;
        font-weight 400;
        i {
          font-weight 100;
          font-style normal;
          font-size 24px;
        }
      }
      &.sub_item {
        line-height 44px;
        font-size 24px;
        color #666;
        span {
          font-size 24px;
          color #999;
        }
      }
      &.type_item {
        font {
          font-weight 400;
          color #39bac0;
        }
      }
    }
    .err_message {
      color #ff0000;
      font-size 20px;
      line-height 36px;
      text-align center;
      padding 120px 0 0;
    }
    .loading_message {
      color #999;
      font-size 12px;
      line-height 24px;
      text-align center;
      padding 140px 0 0;
    }
  }

  .dialog-check-list{
    position :fixed;
    top:15vh;
    left:10%;
    width:80%;
    box-sizing :border-box;
    border-radius: 6px;
    background: #f9f9f9; 
    padding: 20px; 
    height: 60vh; 
    overflow-x: hidden; 
    overflow-y: auto;
    z-index:3;
    font-family: sans-serif;
    font-size:28px;
  }
  .mask{
    position :fixed;
    top:0;
    left:0;
    z-index:2;
    width:100vw;
    height:100vh;
    background:rgba(0,0,0,0.6);
  }
</style>
